export default {
  card: {
    title: '刷卡支付',
    inputs: {
      number: {
        title: '卡号',
        placeholder: '请输入卡号',
      },
      cvc: {
        title: '安全码',
        placeholder: '安全码',
      },
      expiry: {
        title: '月/年',
        placeholder: '月/年',
      },
    },
  },
  'driver-tips': {
    title: '感谢您<br><span>支持司机！</span>',
    description: '您的小费100%直接给司机',
    remember: '请记住，是否给小费完全由您决定！',
    'confirmation-modal': {
      title: '请确认：',
      description: '您确定要发送小费金额为',
      error: '小费金额必须在2美元到40美元之间。',
      actions: {
        confirm: '确认',
        cancel: '取消',
      },
    },
  },
  'tips-amount': {
    other: '其他',
  },
  'tips-component': {
    thanks: '谢谢！您的小费已收到，肯定会让司机的心情更好。',
    more: '继续发送小费',
  },
  'tips-old': {
    title: '感谢您<br><span>支持司机！</span>',
    description: '您的小费100%直接给司机',
    btn: '刷卡支付',
  },
}
